import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { getThemeSpacing } from '../../styles/appTheme'
import {
    maxWindowWidth,
    smallHeightDialogCheck,
} from '../../styles/breakpoints'
import { palette } from '../../styles/colors'

export const MOBILE_SEARCH_HEIGHT = 84
export const DESKTOP_SEARCH_HEIGHT = 50

export const StyledNoResults = styled('article')({
    justifyContent: 'center',
    height: '100%',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
})

export const titleStyles = css({
    font: 'inherit',
    alignItems: 'center',
    fontWeight: 600,
    display: 'flex',
    width: '100%',
    fontSize: '0.7rem',
    color: palette.drawerLabel,
    paddingBottom: getThemeSpacing(0.5),
    [maxWindowWidth(370)]: {
        fontSize: '0.6rem',
    },
})

export const StyledResponsiveGrid = styled('div')({
    display: 'grid',
    height: '100%',
    overflowY: 'auto',
    paddingLeft: getThemeSpacing(1),
    paddingRight: getThemeSpacing(1),
    paddingBottom: getThemeSpacing(1),
    paddingTop: 4,
    columnGap: getThemeSpacing(1),
    // [minWidth(768)]: {
    //     display: 'grid',
    //     gridTemplate: 'repeat(100,  1fr) / 50% 50%',
    //     paddingRight: getThemeSpacing(1),
    // },
    // [minWidth(1500)]: {
    //     display: 'grid',
    //     gridTemplate: 'repeat(100,  1fr) / 33% 33% 33%',
    //     paddingRight: getThemeSpacing(1),
    // },
    // [minWidth(APP_BREAKPOINTS.xxl)]: {
    //     display: 'grid',
    //     gridTemplate: 'repeat(100,  1fr) / 25% 25% 25% 25%',
    //     paddingRight: getThemeSpacing(1),
    // },
    // ...NO_SCROLLBAR_STYLES,
})

export const noResultStyles = css({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 0,
    [smallHeightDialogCheck]: {
        height: 240,
    },
})
